export enum AppModeEnum {
  choose,
  discover,
  join,
  favourites
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/enums/appMode.enum.ts